import { Component } from 'react'
import PropTypes from 'prop-types'

class StoreGift extends Component {
  render() {
    const { title, classes } = this.props
    return (
      <div className={`ctp-store-gift ${classes || ''}`}>
        <div className="ctp-store-gift__inner">
          <strong>{title}</strong>
        </div>
      </div>
    )
  }
}

StoreGift.propTypes = {
  classes: PropTypes.string,
  title: PropTypes.string,
}

export default StoreGift
